import React from 'react'
import { isProduction } from '../../parameters'
import { CustomPurposes, CustomVendors } from '../cmp/cmp.constants'

const getDomainforUtiq = () => (isProduction() ? 'mappy' : 'mappyrecette')

const UtiqLoader = () => {
  const domainForUtiq = getDomainforUtiq()
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.Utiq = window.Utiq || {};
window.Utiq.config = {
  CMP: "Didomi",
  customUtiqHost: "https://utiq.${domainForUtiq}.com",
  didomiUtiqPurposeId: "${CustomPurposes.Utiq}",
  didomiUtiqVendorId: "${CustomVendors.Utiq}"
};
`.replaceAll('\n', '')
        }}
      ></script>
      <script type="text/javascript" src={`https://utiq.${domainForUtiq}.com/utiqLoader.js`} defer></script>
    </>
  )
}

export default UtiqLoader
